/**
 * Guides & Surveys (Amplitude Engagement) helpers for the Vue SPA.
 * @see https://amplitude.com/docs/sdks/guides-and-surveys/sdk
 */

/**
 * @param {import('vue-router').Router} router
 */
export function configureAmplitudeEngagementRouter(router) {
  const applyRouter = () => {
    if (globalThis.window === undefined || typeof globalThis.window.engagement?.setRouter !== 'function')
      return false

    globalThis.window.engagement.setRouter((url) => {
      try {
        const parsed = new URL(url, globalThis.window.location.origin)
        router.push({
          path: parsed.pathname,
          query: Object.fromEntries(parsed.searchParams.entries()),
          hash: parsed.hash,
        })
      }
      catch {
        router.push(url)
      }
    })

    return true
  }

  if (applyRouter())
    return

  globalThis.window.setTimeout(applyRouter, 0)
}

/**
 * Maps vue-i18n locale codes to Amplitude Guides & Surveys locale codes.
 * @param {string} locale
 */
export function mapLocaleToAmplitudeEngagement(locale) {
  if (!locale)
    return

  const normalized = locale.toLowerCase()

  if (normalized.startsWith('pt'))
    return 'pt'
  if (normalized.startsWith('es'))
    return 'es'
  if (normalized.startsWith('en'))
    return 'en'

  return normalized.split('-')[0]
}

/**
 * @param {string} locale
 */
export async function syncAmplitudeEngagementLocale(locale) {
  const engagementLocale = mapLocaleToAmplitudeEngagement(locale)

  if (!engagementLocale || globalThis.window === undefined)
    return

  if (typeof globalThis.window.engagement?.updateLanguage === 'function') {
    await globalThis.window.engagement.updateLanguage(engagementLocale)
  }
}
